import { withFieldHint } from "@/src/components/HighOrderComponents";
import { RadioCardGroup } from "@/src/components/RadioCard";
import { useFormContext } from "react-hook-form";

const RadioCardGroupWithHint = withFieldHint(RadioCardGroup);
export function RadioCard(props: any) {
  const { hint, name, ...restProps } = props;

  const { control } = useFormContext();

  const hints = props?.hint?.hintsList;

  return (
    <RadioCardGroupWithHint {...restProps} control={control} name={name} />
  );
}
